import { spinnerActionTypes } from '@constants/actionTypes/commonActionTypes';

export const INITIAL_STATE = {
    activeSpinnersQty: 0,
    message: null
};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case spinnerActionTypes.START_SPINNER:
            return {
                activeSpinnersQty: state.activeSpinnersQty + 1,
                message: action.message
            };
        case spinnerActionTypes.STOP_SPINNER:
            if (state.activeSpinnersQty === 0) {
                throw new Error('Stop spinner invoked before start spinner');
            }
            return {
                activeSpinnersQty: state.activeSpinnersQty - 1,
                message: state.activeSpinnersQty === 1 ? null : state.message
            };
        case spinnerActionTypes.CLEAR_COMMON_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};